export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILED = "USER_LOGIN_FAILED";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_PAN = "USER_PAN";
export const USER_LOGIN_REFRESH_SUCCESS = "USER_LOGIN_REFRESH_SUCCESS";
export const POSTER_OPEN = "POSTER_OPEN";
